import type { Messages } from './en';

/** Textos de la fase D (aula). `phrases` y `contest.words` son práctica de inglés y se quedan en inglés. */
export const esClassroom: Pick<Messages, 'classroom'> = {
  classroom: {
    mapNames: {},
    zones: {},
    objects: {
      cls_lostBox: 'Caja de objetos perdidos',
      cls_notice: 'Tablón de anuncios',
      cls_ball: 'Pelota del patio',
    },
    npc: {
      xiaohua: 'Xiaohua',
      xiaomei: 'Xiaomei',
      azhe: 'Azhe',
      xiaoqiang: 'Xiaoqiang',
      xiaofang: 'Xiaofang',
    },
    items: {},

    /** PRÁCTICA DE INGLÉS: se queda en inglés. */
    phrases: {
      late: 'Sorry I’m late. It won’t happen again.',
      homework: 'Excuse me, could you help me? I don’t understand this part.',
      standing: 'I’m sorry for talking. I’ll raise my hand next time.',
      ball: 'I feel sad when I don’t get a turn.',
      forgotHomework: 'I’m sorry, I forgot my homework. I’ll bring it next time.',
      misunderstanding: 'Excuse me, I think there’s a misunderstanding.',
      bullying: 'Stop, please. That’s not kind.',
      contest: 'Could you repeat the word, please?',
    },

    ui: {
      sayIt: '🔊 Dilo en inglés',
      practised: '🗣️ ¡Frase en inglés practicada!',
      journalMenu: '📔 Diario de crecimiento',
      journalTitle: '📔 Diario de crecimiento',
      tabPeople: 'Amigos y familia',
      tabLog: 'Momentos',
      tabHobbies: 'Aficiones',
      family: 'Familia',
      classmates: 'Compañeros y amigos',
      noLog: 'Aún no hay nada escrito. Sal a vivir tus días: las decisiones amables, los momentos valientes y hasta los errores acaban aquí.',
      noHobbies: 'Aún no has practicado ninguna afición. ¡Prueba el piano, el caballete, el campo o la biblioteca!',
      hobbyLevel: (n: number) => `Nv ${n}`,
      hobbyPoints: (n: number) => `${n} sesiones`,
      dayLabel: (week: number, day: string) => `Semana ${week} · ${day}`,
      todayRow: 'Momentos de hoy',
      noticeTitle: '📌 Tablón de anuncios',
      noticeNone: 'Hoy no hay nada especial. ¡Que tengas un gran día en el cole!',
      noticeCases: 'Puede que hoy algún compañero necesite un amigo. ¡Estate atento!',
      lateGone: 'Xiaohua ya ha entrado. Aún puedes ser amable con él más tarde.',
      later: 'Hablamos luego',
      back: '‹ Volver',
      tryAgain: 'Mmm, prueba de otra manera.',
      narrator: 'Mientras tanto…',
      ballIdle: 'Un balón de fútbol gastado con «小強» escrito con rotulador. Seguro que Xiaoqiang se lo ha dejado aquí.',
      chat: '💬 Charlar',
      giveBack: (what: string) => `🎁 Devolver ${what}`,
      coolHello: ['Ah… hola.', 'Mm. Hola.', '…Hola.'],
      warmHello: ['¡Eh, mejor amigo!', '¡Bien, eres tú!', '¡Ahí estás! Tenía ganas de verte.'],
    },

    love: ['Desconocidos', 'Conociéndonos', 'Amigos', 'Buenos amigos', 'Mejores amigos'],
    loveFamily: ['Distantes', 'Bien', 'Unidos', 'Muy unidos', 'Inseparables'],

    hobbies: {
      music: '🎵 Música', art: '🎨 Arte', sport: '⚽ Deporte', reading: '📚 Lectura', nature: '🌿 Naturaleza', craft: '✂️ Manualidades',
      cooking: '🍳 Cocina', garden: '🌱 Jardinería', english: '🗣️ Inglés', dance: '💃 Baile',
    },

    journalKeys: {
      helpedLate: () => 'Ayudé a Xiaohua a pedir perdón por llegar tarde… y le di un truco con el despertador',
      lateExcuse: () => 'Le dije a Xiaohua que se inventara una excusa. No salió bien.',
      teasedLate: () => 'Me reí de Xiaohua cuando llegó tarde',
      helpedHomework: () => 'Ayudé a Xiaomei a pedir ayuda a la profe, con sinceridad',
      copiedHomework: () => 'Dejé que Xiaomei copiara mis deberes. Seguía sin entenderlos.',
      skippedHomework: () => 'Le dije a Xiaomei que fingiera estar enferma',
      helpedStanding: () => 'Ayudé a Azhe a calmarse y a arreglarlo con la profesora Lin',
      clowned: () => 'Hice muecas con Azhe en clase y nos regañaron a los dos',
      mockedStanding: () => 'Le dije «te lo mereces» a Azhe',
      ballMadeUp: () => 'Ayudé a Xiaoqiang y a Xiaofang a usar frases con «Me siento…» y a turnarse',
      ballSide: (who?: string) => `Me puse del lado de ${who ?? 'uno'} en la pelea por la pelota`,
      ballGrabbed: () => 'Cogí la pelota y salí corriendo. Nadie se rio.',
      madeUp: (who?: string) => `Pedí perdón a ${who ?? 'un amigo'} y hicimos las paces`,
      forgotHonest: () => 'Me olvidé los deberes y le dije la verdad a la profe',
      forgotExcuse: () => 'Me olvidé los deberes y me inventé una excusa',
      homeworkMadeUp: () => 'Hice en el recreo los deberes que me faltaban',
      lostFound: () => 'Perdí mi estuche… y lo encontré en la caja de objetos perdidos',
      returnedItem: (who?: string) => `Le devolví a ${who ?? 'un compañero'} algo que había perdido`,
      calmExplained: () => 'Le expliqué con calma un malentendido a la profesora Lin',
      shouted: () => 'Le grité a la profesora Lin por un malentendido',
      bullyStood: () => 'Me quedé al lado de Bo cuando unos mayores se burlaban de él',
      bullyTold: () => 'Avisé a un adulto cuando se burlaban de Bo',
      bullyIgnored: () => 'Me fui cuando se burlaban de Bo',
      contestWin: () => '¡Gané el concurso de deletreo de la clase!',
      contestSetback: () => 'No gané el concurso de deletreo… todavía. Seguiré practicando.',
      quiz: (grade?: string) => `Examen sorpresa: nota ${grade ?? '?'}`,
      meeting: (how?: string) => (how === 'great' ? 'Reunión de padres: la profesora Lin dijo cosas preciosas de mí' : how === 'mixed' ? 'Reunión de padres: algunas buenas noticias y algunas cosas que mejorar' : 'Reunión de padres: mamá y yo hicimos un plan juntos'),
    },

    kids: {
      xiaohua: {
        hello: ['¡Hola! ¿Llego tarde? …Uf, menos mal. Ni siquiera es la hora de clase.', '¡Eh! ¿Has dormido bien? Yo siempre duermo demasiado bien.'],
        topics: [
          { say: 'Mi abuelo dice que a quien madruga Dios le ayuda. Yo digo que quien madruga tiene mucho sueño.', choices: [{ t: '¡Jaja! ¿Y si te acuestas antes?', reply: 'Mmm… quizá si dejo de leer cómics debajo de la manta.' }, { t: '¿Qué te gusta leer?', reply: '¡Cómics de gatos espaciales! La capitana es una gata que se llama Mochi.' }] },
          { say: 'Estoy ahorrando para un kit de cohete. ¡Tiene una plataforma de lanzamiento de verdad!', choices: [{ t: '¡Qué guay! ¿Me lo enseñas cuando lo montes?', reply: '¡Sí! Tú puedes hacer la cuenta atrás: tres, dos, uno…' }, { t: '¿Cuánto te falta?', reply: 'Dos semanas más sin comprar chuches. Puf.' }] },
        ],
        react: {
          alarm: '¿Sabes qué? Anoche puse dos alarmas y preparé la mochila. ¡Hoy he llegado PRONTO! ¡Gracias por el truco!',
          excuse: 'La excusa no funcionó… la profesora Lin lo sabía. La próxima vez diré la verdad y ya está.',
          teased: '…Ah. Eres tú. Por favor, no te vuelvas a reír de mí. Me hizo sentir muy pequeño.',
          madeUp: 'Ya estamos bien. Gracias por pedirme perdón: has estado genial.',
        },
        apologise: 'Pedirle perdón por reírte de él',
        apologyReply: 'Vale… gracias. Ya está bien. ¿Quieres ver mi cómic de gatos espaciales?',
      },
      xiaomei: {
        hello: ['¡Oh! Hola… estaba leyendo.', 'Hola. ¿A ti también te gusta la biblioteca?'],
        topics: [
          { say: 'He terminado un libro sobre una niña que habla con las ballenas. Lloré al final. ¿Es raro?', choices: [{ t: 'Nada raro. Los buenos libros hacen eso.', reply: 'Gracias… te lo presto si quieres.' }, { t: '¡Las ballenas de verdad pueden «hablar»!', reply: '¿En serio? Cantan canciones que llegan muy lejos. ¡Eso también lo leí!' }] },
          { say: 'Estoy intentando ser más valiente. Hoy le he dicho «buenos días» al conductor del autobús.', choices: [{ t: '¡Qué valiente! Los pasitos pequeños cuentan.', reply: '¡Me ha dicho buenos días también! Me he puesto muy contenta.' }, { t: '¡La próxima vez, dilo en inglés!', reply: 'Good… morning! Jiji. Lo he conseguido.' }] },
        ],
        react: {
          asked: 'La profesora Lin me ayudó con el ejercicio 3. ¡Ahora lo entiendo! Preguntar daba miedo… pero valió la pena.',
          copied: 'Sigo sin entender el ejercicio 3… Copiar no me ayudó a aprender. ¿La próxima vez me lo explicas?',
          skipped: 'Me escondí en la enfermería, pero no estaba enferma. Me sentí peor, no mejor.',
          madeUp: 'Gracias por pedirme perdón. ¿Estudiamos juntas algún día?',
        },
        apologise: 'Pedirle perdón por el mal consejo',
        apologyReply: 'No pasa nada. Los dos hemos aprendido algo. ¿Hacemos los deberes juntos la próxima vez?',
      },
      azhe: {
        hello: ['¡Eh! ¿Quieres oír un chiste? …Luego. Estoy practicando el autocontrol. Jeje.', '¡Ey, ey! ¿Qué pasa?'],
        topics: [
          { say: '¿Por qué se comió el alumno los deberes? ¡Porque la profe dijo que eran pan comido!', choices: [{ t: '¡Jaja! Es malísimo. Me encanta.', reply: 'Tengo cien más. ¡Me los guardo para el recreo!' }, { t: '¡Cuéntame otro!', reply: '¿Qué tiene cuatro ruedas y moscas? ¡Un camión de la basura! ¡Jajaja!' }] },
          { say: 'De mayor quiero ser presentador de la tele. ¡Hablar es mi superpoder!', choices: [{ t: '¡Lo harías genial!', reply: '¿A que sí? Pero un buen presentador también sabe cuándo escuchar. Esa parte la estoy aprendiendo.' }, { t: 'Pero los superpoderes hay que controlarlos.', reply: 'Ja, eso dice la profesora Lin. Deberíais montar un club.' }] },
        ],
        react: {
          calm: 'Hoy he levantado la mano tres veces y he esperado todas. ¡La profesora Lin me ha dado una pegatina!',
          clowned: 'Ayer nos metimos los dos en un lío, ¿eh? Mejor guardamos las muecas para el recreo.',
          mocked: 'Hmpf. Lo de «te lo mereces» no estuvo nada bien, ¿sabes?',
          madeUp: '¡Todo bien, amigo! Todo el mundo dice tonterías a veces. ¡Yo el que más!',
        },
        apologise: 'Pedirle perdón por haber sido borde',
        apologyReply: '¡Disculpa aceptada! ¿Chocamos esos cinco? ✋',
      },
      xiaoqiang: {
        hello: ['¡Eh! ¿Jugamos a la pelota en el recreo?', '¡Ey! ¡Ayer metí tres goles en el campo!'],
        topics: [
          { say: 'Voy a ser futbolista profesional. Aunque el entrenador dice que tengo que pasar más.', choices: [{ t: '¡Pasar hace mejor a todo el equipo!', reply: 'Ya, ya… estoy en ello. Xiaofang pasa muy bien, la verdad.' }, { t: '¿Me enseñas un truco?', reply: '¡Claro! Pisas la pelota, la echas atrás y te giras. ¡Fácil!' }] },
          { say: 'Mi padre y yo vemos béisbol todos los domingos. Le grita a la tele. Es superdivertido.', choices: [{ t: '¿Cuál es tu equipo favorito?', reply: '¡Los Brothers! ¡Amarillo para siempre!' }, { t: '¿Y la tele le grita a él?', reply: '¡Jaja! No, ¡pero mi madre sí!' }] },
        ],
        react: {
          madeUp: 'Xiaofang y yo ahora nos turnamos. Cinco minutos cada uno. ¿Sinceramente? Es más divertido entre dos.',
          sideMe: 'Gracias por ponerte de mi lado ayer… pero ahora Xiaofang no me habla. Es un rollo.',
          sideOther: 'Ayer te pusiste del lado de Xiaofang. Todavía estoy molesto.',
          grabbed: 'No mola salir corriendo con mi pelota. No es un juguete para hacer rabiar.',
          madeUpYou: 'Vale, volvemos a estar bien. Gracias por pedir perdón.',
        },
        apologise: 'Pedir perdón y hablarlo',
        apologyReply: 'Vale. Supongo que yo tampoco lo hice muy bien. La próxima vez jugamos todos juntos.',
      },
      xiaofang: {
        hello: ['¡Hola! ¿Has visto las nubes esta mañana? Una parecía un conejo.', '¡Eh! Estoy practicando los tiros libres. ¿Quieres mirar?'],
        topics: [
          { say: 'Hay gente que dice que el fútbol es cosa de chicos. Qué tontería. A la pelota le da igual quién la chute.', choices: [{ t: '¡Totalmente! Juegas muy bien.', reply: '¡Gracias! Practico todas las mañanas antes del cole.' }, { t: '¡A ver si jugamos juntos algún día!', reply: '¡Trato hecho! Te enseño mi tiro con efecto.' }] },
          { say: 'Cuando me enfado, cuento hasta diez y aprieto los puños. Luego los suelto. Funciona… casi siempre.', choices: [{ t: 'Es un truco genial.', reply: 'Me lo enseñó mi hermana mayor. Dice que los sentimientos son como olas: pasan.' }, { t: 'Yo respiro hondo.', reply: 'Oh, eso también lo probaré. Dentro… y fuera.' }] },
        ],
        react: {
          madeUp: 'Turnarse es muchísimo mejor que pelearse. ¡Y Xiaoqiang me pidió perdón! ¡Eso no pasa nunca!',
          sideMe: 'Gracias por defenderme. Pero… la próxima vez quizá podrías ayudarnos a los dos, ¿vale?',
          sideOther: 'Te pusiste del lado de Xiaoqiang. De verdad creía que eras mi amigo.',
          grabbed: 'Eso no tuvo gracia. Ya estábamos disgustados.',
          madeUpYou: 'Gracias por pedir perdón. ¡Amigos otra vez!',
        },
        apologise: 'Pedir perdón y hablarlo',
        apologyReply: 'Vale. Gracias por volver a decírmelo. Eso tiene mérito.',
      },
    },

    react: {
      teacher: {
        honest: 'Gracias otra vez por decirme la verdad sobre los deberes. La sinceridad lo hace todo más fácil.',
        calm: 'Todavía siento lo del malentendido del otro día. Me lo explicaste con tanta calma que aprendí de ti.',
        helped: 'Me he fijado en cómo ayudas a tus compañeros. Eso es lo que hace un buen amigo.',
      },
      bo: {
        stood: 'Gracias por quedarte a mi lado en el parque. Ahora, cuando veo a esos niños, me siento más valiente.',
        told: 'El tío Chun habló con esos niños mayores. ¡Me pidieron perdón! Gracias por avisarle.',
        ignored: 'Vi que te ibas en el parque… No pasa nada. Solo que… la próxima vez, ¿te quedas conmigo?',
      },
      mom: {
        meeting: 'Todavía sonrío al pensar en lo que dijo la profesora Lin en la reunión de padres.',
      },
      festival: (name: string) => `¡Feliz ${name}! ¿A que esta semana es divertida?`,
      trip: (place: string) => `¡Me han dicho que fuiste a ${place}! ¿Qué es lo que más te gustó?`,
      typhoon: '¡Menudo tifón! Quédate en casa y ten cuidado, ¿vale?',
      rain: '¡Cuánta lluvia hoy! ¿Has traído paraguas?',
    },

    cases: {
      late: {
        open: '¡Ay, no, ay, no! ¡Me he dormido y ya ha sonado el timbre! La profesora Lin se va a enfadar muchísimo… ¿Y si me escondo en el baño hasta el recreo?',
        good: 'Esconderte lo empeora. Vamos a entrar y a pedir perdón juntos.',
        excuse: 'Dile que el autobús llegó tarde.',
        tease: '¡Jaja! ¡Llegas SÚPER tarde!',
        how: 'Pero… ¿qué le digo?',
        howGood: 'Pide perdón, di la verdad y promete que te esforzarás más.',
        howQuiet: 'Entra sin hacer ruido. A lo mejor no se da cuenta.',
        quietReply: 'Colarme me da miedo… ¿Y si me ve? Creo que es mejor decírselo.',
        phraseIntro: 'Vamos a practicarlo juntos, en inglés, como nos enseñó la profesora Lin:',
        plan: '¡Vale, se lo diré! Pero ¿cómo hago para no llegar tarde la próxima vez?',
        planAlarm: 'Pon una alarma y deja el reloj lejos de la cama.',
        planBag: 'Prepara la mochila la noche antes.',
        planBoth: '¡Las dos cosas! Una alarma Y la mochila lista junto a la puerta.',
        planReply: 'Es un plan genial. ¡Lo voy a probar esta noche!',
        teacher: 'Gracias por decírmelo con sinceridad, Xiaohua. Todo el mundo llega tarde alguna vez; lo que importa es lo que hacemos después. Ven a sentarte.',
        thanks: 'Uf… No ha sido para tanto. ¡Gracias por ayudarme!',
        excuseEnd: 'Xiaohua le dice a la profesora Lin que el autobús llegó tarde. Ella le responde con calma que vio llegar su autobús a la hora. Ahora tiene que explicarlo dos veces… Las excusas suelen complicar las cosas.',
        teaseEnd: 'Xiaohua mira al suelo y entra solo. Tiene las orejas rojísimas. ¿Cómo te sentirías tú?',
      },
      homework: {
        open: 'Yo… no he terminado los deberes de mates. No entendía el ejercicio 3, así que… lo dejé. Si entro, todos lo verán.',
        good: 'No pasa nada por no entenderlo. Vamos a pedirle ayuda a la profesora Lin, con sinceridad.',
        copy: '¡Rápido, copia los míos!',
        sick: 'Ve a la enfermería y di que te encuentras mal.',
        scared: 'Pero ¿y si se enfada? ¿Y si digo algo mal?',
        brave: 'Decir «no lo sé» es de valientes. A los profes les gustan las preguntas.',
        withYou: 'Te acompaño. No vas a estar sola.',
        braveReply: 'Valiente… vale. Puedo ser valiente.',
        withYouReply: '¿De verdad? Gracias… así es más fácil.',
        phraseIntro: 'Podrías decirlo así, en inglés, para practicar:',
        teacher: 'Gracias por decírmelo, Xiaomei. No entender algo es como empieza el aprendizaje. Miremos juntas el ejercicio 3 en el recreo.',
        thanks: '¡No se ha enfadado nada! Me alegro de haber preguntado. Gracias por ser mi amigo.',
        copyEnd: 'Xiaomei copia tus respuestas. En clase, la profesora Lin le pide que explique el ejercicio 3… y no puede. Te mira en silencio. Copiar no la ayudó a aprender.',
        sickEnd: 'La enfermera revisa a Xiaomei con cariño y le dice que no está enferma. Xiaomei se pierde la clase y sigue sin entender el ejercicio 3.',
      },
      standing: {
        open: '¡Psst! La profesora Lin me ha mandado al fondo de pie porque no paraba de hablar. ¡Qué injusto! Oye, ¿quieres ver mi cara graciosa? 😜',
        good: 'Ahora no. No nos metamos en más líos. ¡Me lo cuentas en el recreo!',
        clown: 'Hacerle muecas tú también.',
        mock: 'Te lo mereces.',
        why: '…Ya, vale. No lo hago queriendo. Es que me emociono y las palabras se me escapan.',
        tipWrite: 'Cuando se te ocurra algo, apúntalo y me lo cuentas luego.',
        tipBreathe: 'Respira hondo y levanta la mano. Espera tu turno.',
        tipReply: 'Anda. Eso podría funcionar. ¡Como una libreta secreta de chistes!',
        fix: '¿Debería decirle algo a la profesora Lin?',
        fixGood: 'Sí. Pídele perdón y cuéntale tu plan.',
        fixLater: 'Quizá esperar a que se le olvide.',
        fixLaterReply: 'Mmm… creo que no se le va a olvidar. Es mejor arreglarlo. Vamos.',
        phraseIntro: 'Digámoslo juntos, en inglés:',
        teacher: 'Gracias, Azhe. Veo que te estás esforzando de verdad. Siéntate, y me encantará oír tus ideas cuando te toque.',
        thanks: '¡Síii! Autocontrol: ¡nivel uno! Gracias, colega.',
        clownEnd: 'La profesora Lin se gira y os ve a los dos haciendo muecas. «¿Ahora sois dos?», dice con calma. Os quedáis de pie hasta que suena el timbre. Ya no tiene tanta gracia.',
        mockEnd: 'Azhe deja de sonreír. «Vaya. Muchas gracias», murmura, y aparta la mirada.',
      },
      ball: {
        open: '—¡Es MI pelota! ¡La he traído yo! —grita Xiaoqiang.\n—¡Pero la has tenido TODO el recreo! ¡Me toca a mí! —grita Xiaofang.',
        calm: 'Eh, vamos a calmarnos. ¿Podéis decir cada uno cómo os sentís?',
        sideQiang: '«Xiaoqiang tiene razón. Es su pelota.»',
        sideFang: '«Xiaofang tiene razón. ¡Compartid!»',
        grab: '¡Coger la pelota y salir corriendo!',
        iIntro: 'Prueba a decirlo así: «Me siento… cuando… porque…». ¿Cuál es un mensaje en primera persona?',
        iGood: '«Me siento triste cuando no me toca, porque yo también quiero jugar.»',
        iBad1: '«¡Eres SÚPER egoísta!»',
        iBad2: '«¡Siempre lo estropeas todo!»',
        iBadReply: 'Esa frase culpa a la otra persona y provoca una pelea más grande. Un mensaje en primera persona habla de lo que sientes TÚ.',
        iReply: 'Xiaofang respira hondo y lo dice. Xiaoqiang parpadea. «Ah… no sabía que te sentías triste.»',
        phraseIntro: 'Aquí tienes ese mensaje en inglés; dilo con ella:',
        solve: 'Entonces… ¿qué hacemos ahora?',
        turns: 'Turnaos: cinco minutos cada uno.',
        together: '¡Jugad juntos! Pasaos la pelota.',
        solveReply: '«Vale… perdón por gritar», dice Xiaoqiang. «Perdón yo también», dice Xiaofang. «¿Jugamos juntos?»',
        thanks: 'Gracias por ayudarnos. ¡Ha sido mejor que pelearnos!',
        sideQiangEnd: 'Xiaoqiang sonríe y se va corriendo con la pelota. A Xiaofang se le llenan los ojos de lágrimas. «Vale. Me da igual.» Se marcha sola.',
        sideFangEnd: 'Xiaoqiang tira la pelota al suelo. «¡Pues quédatela! ¡Estáis todos contra mí!» Se va dando pisotones.',
        grabEnd: 'Sales corriendo con la pelota. Nadie se ríe. Ahora Xiaoqiang y Xiaofang están enfadados entre ellos Y contigo.',
      },
    },

    events: {
      forgotHomework: {
        ask: 'Buenos días a todos. Por favor, entregad los deberes de la semana pasada… ¿Oh? ¿No tienes los tuyos?',
        honest: 'Lo siento, me los he olvidado.',
        excuse: '¡Se los ha comido mi perro!',
        honestReply: 'Gracias por ser sincero. Eso es lo más importante. Puedes hacerlos en el recreo o traerlos la próxima vez.',
        excuseReply: 'Mmm. Prefiero oír la verdad; no me voy a enfadar. ¿Te los has olvidado?',
        admit: 'Sí… me los he olvidado. Perdón.',
        admitReply: 'Gracias. ¿Ves? La verdad pesa menos.',
        makeUp: '📝 Hacerlos ahora en el recreo',
        later: 'Traerlos la próxima vez',
        doneReply: '¡Muy bien! Gracias por arreglarlo.',
      },
      lostPencil: {
        start: '😟 ¡Oh, no! Tu estuche no está en la mochila. ¿Y si miras en la caja de objetos perdidos del pasillo?',
        found: '¡Ahí está: tu estuche, con tu nombre en la etiqueta! Alguien amable lo habrá entregado.',
        idle: 'Una caja de cosas perdidas: un guante solitario, una botella de agua, tres gomas de borrar…',
        other: (what: string, who: string) => `Hay ${what} con un nombre: «${who}».`,
        give: (who: string) => `Llevárselo a ${who}`,
        leave: 'Dejarlo',
        thanks: '¡Lo que había perdido! ¡Muchísimas gracias por traérmelo!',
        items: { eraser: 'una goma de dinosaurio', bottle: 'una botella de agua azul', ruler: 'una regla brillante', bookmark: 'un marcapáginas de gato', keychain: 'un llavero de osito' },
        carrying: (what: string, who: string) => `Llevas ${what} para ${who}.`,
      },
      misunderstanding: {
        ask: 'Alguien ha derramado el agua de las pinturas en el aula de plástica y lo ha dejado así. ¿Has sido tú? Estoy decepcionada.',
        calm: 'Mantener la calma y explicarlo.',
        shout: '¡Es SÚPER injusto! ¡Siempre me echas la culpa!',
        silent: 'No decir nada y enfurruñarse.',
        explain: 'A esa hora yo estaba en la biblioteca, no en el aula de plástica. Pero puedo ayudar a limpiarlo.',
        calmReply: 'Oh… tienes razón, la bibliotecaria te vio. Siento haber sacado conclusiones tan rápido. Gracias por explicarlo con tanta calma, y por ofrecerte a ayudar.',
        shoutReply: 'Entiendo que estés disgustado. Pero si gritas me cuesta escucharte. ¿Me lo puedes contar con calma?',
        silentReply: 'No puedo saber qué ha pasado si no me lo cuentas. Respira hondo; te escucho.',
        tryCalm: 'Respirar hondo y explicarlo con calma.',
      },
      bullying: {
        start: '😢 Oyes a alguien llorar cerca del árbol de las cometas, en el parque…',
        open: 'Dos niños mayores se ríen de la cometa de Bo. «¡Cometa de bebé! ¡Cometa de bebé!» Bo intenta no llorar.',
        stand: 'Ponerte al lado de Bo y decir con calma: «Parad, por favor. Eso no está bien.»',
        tell: 'Ir a avisar a un adulto (el tío Chun o la mamá de Bo).',
        fight: '¡Empujarlos!',
        ignore: 'Irte y hacer como que no lo has visto.',
        fightReply: 'Pelearse lo empeora todo: alguien podría hacerse daño y entonces TÚ también te meterías en un lío. Hay una forma más valiente.',
        standReply: 'Los mayores se quedan sorprendidos. «Bah, lo que sea», murmuran, y se van. Bo se seca los ojos. «Te… has quedado. Gracias.»',
        tellReply: 'Un adulto se acerca y habla en voz baja con los mayores. Le piden perdón a Bo. Avisar no es chivarse: es pedir ayuda.',
        ignoreReply: 'Te vas. Detrás de ti, las risas continúan. Toda la tarde notas un peso en la barriga.',
        boThanks: 'Eres un amigo de verdad. ¿Quieres volar mi cometa conmigo?',
      },
      contest: {
        notice: '🐝 ¡Concurso de deletreo de la clase a las 2 de la tarde! Ven al tablón de anuncios para apuntarte.',
        intro: '¡Bienvenidos al concurso de deletreo de la clase! Tres palabras. Escuchad con atención y elegid cómo se escribe.',
        join: '🐝 Apuntarse al concurso de deletreo',
        notYet: 'El concurso de deletreo empieza a las 2 de la tarde.',
        over: 'El concurso de deletreo ya ha terminado por hoy.',
        word: (n: number) => `Palabra ${n} de 3. Escucha… 🔊`,
        hear: '🔊 Volver a escuchar',
        right: '✅ ¡Correcto!',
        wrong: (w: string) => `❌ ¡Uy! Se escribe «${w}».`,
        win: '🏅 ¡Has ganado el concurso de deletreo! La profesora Lin te pone una abeja dorada en la camiseta. ¡Todo el mundo aplaude!',
        setback: 'Esta vez has quedado cuarto. Tu amiga Xiaomei ha ganado con «necessary».',
        mindsetQ: 'Profesora Lin: «¿Cómo te sientes?»',
        mindsetGood: '¡Practicaré y lo volveré a intentar la próxima vez!',
        mindsetBad: 'Es que se me da fatal deletrear.',
        mindsetBadReply: 'No se te da mal deletrear: es que TODAVÍA no se te da bien. Todos los expertos fueron principiantes alguna vez. ¿Qué podrías probar la próxima vez?',
        mindsetReply: '¡Así se habla! Practicar un poquito cada día funciona de verdad.',
        winReply: '¡Enhorabuena! Recuerda: has llegado aquí practicando. ¡Sigue así!',
        /** PRÁCTICA DE INGLÉS: palabras para deletrear; se quedan en inglés. */
        words: ['because', 'friend', 'beautiful', 'library', 'Wednesday', 'different', 'tomorrow', 'favourite', 'believe', 'together', 'surprise', 'answer'],
      },
      quiz: {
        start: '¡Hora del examen sorpresa! No os preocupéis: es solo para ver qué hemos aprendido. ¡Hacedlo lo mejor que podáis!',
        go: '📝 Empezar el examen',
        result: (g: string) => (g === 'A' ? '¡Excelente trabajo! ¡Una A!' : g === 'B' ? '¡Buen trabajo, una B! Con un poco más de práctica, volarás.' : 'Esta vez una C. Eso solo nos dice qué tenemos que practicar. Lo conseguiremos juntos.'),
      },
      parentsMeeting: {
        notice: '👨‍👩‍👧 ¡Esta tarde hay reunión de padres! Mamá verá a la profesora Lin después de clase.',
        momIntro: 'Ya he vuelto de la reunión de padres (家長會). La profesora Lin me lo ha contado todo sobre ti…',
        great: 'Me ha dicho que eres amable y que ayudas a tus compañeros. Me ha contado estos momentos:',
        proud: '¡Estoy muy orgullosa de ti!',
        study: 'También me ha dicho que te esfuerzas mucho en los estudios. ¡Sigue así!',
        studyLow: 'Me ha dicho que podrías concentrarte un poco más en estudiar. ¿Hacemos un plan juntos?',
        unkind: 'Me ha comentado que una vez no fuiste muy amable con un compañero. ¿Cómo crees que se sintió?',
        reflect: 'Seguramente se sintió triste. Le pediré perdón.',
        reflectReply: 'Ese es mi niño. Pedir perdón es de valientes.',
        thanksMom: '¡Gracias, mamá! ❤️',
        plan: 'Hagamos un plan de estudio juntos.',
        planReply: 'Bien. Veinte minutos cada tarde, y yo preparo el té. ¿Trato hecho?',
        nothing: 'Me ha dicho que eres un niño encantador, ¡y que le encantaría ver más de lo que sabes hacer!',
        done: 'Mamá te da un abrazo enorme.',
      },
    },
  },
};
